import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderIt = () => {
    return (
        <HighlightedText
            text="CONGRATULAZIONI!"
            highlights={[{ word: 'CONGRATULAZIONI!' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentIt = () => {
    return (
        <HighlightedText
            text="HAI VINTO 400 GIRI GRATUITI"
            highlights={[
                { word: '400' },
                { word: 'GIRI' },
                { word: 'GRATUITI' },
            ]}
            breakBeforeWords={['GIRI']}
            className={styles['text_content--SECOND']}
        />
    )
}
